export const buildTableStandings = (onStandingChange) => [
    {
    value: 'OK',
    content: 'OK',
    color: '#00D374',
    onClick: (item, row) => onStandingChange(item, row),
  },
  {
    value: 'PROBLEM',
    content: 'Problem',
    color: '#FF2674',
    onClick: (item, row) => onStandingChange(item, row),
  },
  {
    value: 'FOLLOWUP',
    content: 'Follow Up',
    color: '#FFAE00',
    onClick: (item, row) => onStandingChange(item, row),
  },

]

export const buildTableStatuses = (statuses = [], onStatusChange) =>
  statuses.map((s, i) => {
    const value = s.key ?? s.value;
    const label = s.label ?? s.value;

    return {
      value,
      content: label,
      order: label === 'Problem' || label === 'Follow Up' ? 0 : i - 1,
      onClick: (item, row) => onStatusChange?.(item, row),
    };
  });